
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mint/[chain]/[contractAddress]/[tokenId]",
      function () {
        return require("private-next-pages/mint/[chain]/[contractAddress]/[tokenId]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mint/[chain]/[contractAddress]/[tokenId]"])
      });
    }
  